import { defineStore } from 'pinia'
import apiService from '../services/api'
import type { AxiosResponse } from 'axios'

// Definim interfața pentru device
interface Device {
  id: number
  remoteAET: string
  name: string
}

export const useDeviceStore = defineStore('DeviceStore', {
  state: () => ({
    devices: [] as Device[],
    device: null as Device | null
  }),

  actions: {
    async fetchDevices() {
      try {
        const response: AxiosResponse<Device[]> =
          await apiService.get(`/device/devices`)
        this.devices = response.data
      } catch (error) {
        console.error('Error fetching devices:', error)
      }
    },

    async fetchDeviceById(deviceId: string) {
      try {
        const response: AxiosResponse<Device> = await apiService.get(
          `/device/devices/${deviceId}`
        )
        this.device = response.data
      } catch (error) {
        console.error('Error fetching device by ID:', error)
      }
    }
  },
  getters: {
    allDevices(state) {
      return state.devices
    },

    currentDevice(state) {
      return state.device
    }
  }
})
